import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import ExportFileModal from 'components/modal/ExportFileModal'
import { formatData } from 'utils/ExportDataUtil'
import { getParametersNature, getParametersType } from 'referencial/util/ReferencialUtils'
import { getStatusInformation } from 'referencial/util/StatusUtils'
import { getLocalizationLabel } from 'utils/AnalyseUtils'
import ExportAction from 'export/actions/ExportAction'
import useListGrouped from 'utils/customHook/useListGrouped'
import useSandreList from 'utils/customHook/useSandreList'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import { Grid, Stack, Typography } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import { useOutletContext } from 'react-router'
import ToastrAction from 'toastr/actions/ToastrAction'
import { isNil, keys, maxBy, orderBy, template, compact } from 'lodash'
import { getDate } from 'date-fns'
import { getTimestamp } from 'utils/DateUtil'
import useListIndexed from 'utils/customHook/useListIndexed'
import SimpleInput from 'components/forms/SimpleInput'
import { formatedFileName } from 'utils/FileUtils'
import moment from 'moment'
import { QUALITY_CAMPAIGN_REQUEST_CONSTANTS } from 'campaign/constants/CampaignConstants'
import { hasValue } from 'utils/NumberUtil'
import { errorColor, warningColor } from 'utils/constants/ColorTheme'

const FormExportEDILABO = ({
    paramEDILABO,
    setParamEDILABO,
    fullForm = false,
}) => {
    const { contributors } = useSelector(store => ({ contributors: store.ContributorReducer.contributors }), shallowEqual)
    return (
        <Grid spacing={1} container justifyContent='center'>
            <Grid size={12}>
                <Input
                    title={i18n.fileName}
                    value={paramEDILABO.requestName}
                    onChange={v => setParamEDILABO(prevParam => ({ ...prevParam, requestName: v }))}
                    obligatory
                />
            </Grid>
            <Grid size={6}>
                <Select
                    options={contributors}
                    label={i18n.sender}
                    onChange={v => setParamEDILABO(prevParam => ({ ...prevParam, sender: v }))}
                    value={paramEDILABO.sender}
                    nullLabel='&nbsp;'
                    clearFunction
                    displayWithCode
                    keyLabel='labelDisplay'
                    obligatory
                />
            </Grid>
            <Grid size={6}>
                <Select
                    options={contributors}
                    label={i18n.receiver}
                    onChange={v => setParamEDILABO(prevParam => ({ ...prevParam, receiver: v }))}
                    value={paramEDILABO.receiver}
                    nullLabel='&nbsp;'
                    clearFunction
                    displayWithCode
                    keyLabel='labelDisplay'
                    obligatory
                />
            </Grid>
            {fullForm && (
                <>
                    <Grid size={6}>
                        <Select
                            options={contributors}
                            label={i18n.laboratory}
                            onChange={v => setParamEDILABO(prevParam => ({ ...prevParam, laboratory: v }))}
                            value={paramEDILABO.laboratory}
                            nullLabel='&nbsp;'
                            clearFunction
                            displayWithCode
                            keyLabel='labelDisplay'
                            obligatory
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            options={contributors}
                            label={i18n.producer}
                            onChange={v => setParamEDILABO(prevParam => ({ ...prevParam, producer: v }))}
                            value={paramEDILABO.producer}
                            nullLabel='&nbsp;'
                            clearFunction
                            displayWithCode
                            keyLabel='labelDisplay'
                            obligatory
                        />
                    </Grid>
                </>
            )}
            <Grid size={6}>
                <SimpleDatePicker
                    id='startDate'
                    label={i18n.startDate}
                    value={paramEDILABO.startDate}
                    onChange={v => setParamEDILABO(prevParam => ({ ...prevParam, startDate: v }))}
                    obligatory
                />
            </Grid>
            <Grid size={6}>
                <SimpleDatePicker
                    id='endDate'
                    label={i18n.endDate}
                    value={paramEDILABO.endDate}
                    onChange={v => setParamEDILABO(prevParam => ({ ...prevParam, endDate: v }))}
                    obligatory
                />
            </Grid>
        </Grid>
    )
}

FormExportEDILABO.propTypes = {
    paramEDILABO: PropTypes.shape({
        requestName: PropTypes.string,
        sender: PropTypes.number,
        receiver: PropTypes.number,
        laboratory: PropTypes.number,
        producer: PropTypes.number,
        startDate: PropTypes.number,
        endDate: PropTypes.number,
    }),
    setParamEDILABO: PropTypes.func,
    fullForm: PropTypes.bool,
}

const QualityCampaignExportPopup = ({
    isOpen = false,
    onClose = () => {},
    planningId,
}) => {
    const dispatch = useDispatch()
    const {
        campaign,
        campaignStations,
        campaignParameters,
        campaignPlannings,
        edilaboFiles,
    } = useOutletContext()
    const {
        qualitometers,
        cities,
        allPoints,
        parameters,
        units,
        fractions,
        supports,
        selections,
        contributors,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        cities: store.CityReducer.cities,
        allPoints: store.QualityReducer.allPoints,
        parameters: store.ParameterReducer.parameters,
        units: store.UnitReducer.units,
        fractions: store.FractionReducer.fractions,
        supports: store.SupportReducer.supports,
        selections: store.ParameterReducer.selectionsWithParam,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)
    const indexedQualitometers = useListIndexed(qualitometers, 'id')
    const indexedCities = useListIndexed(cities, 'id')
    const groupedSamplePoints = useListGrouped(allPoints, 'idQualitometer')
    const codificationsList = useSandreList('QUALITOMETRES.NOMENCLATURES')

    const indexedUnits = useListIndexed(units, 'code')
    const indexedFractions = useListIndexed(fractions, 'code')
    const indexedSupports = useListIndexed(supports, 'code')
    const indexedParameters = useListIndexed(parameters, 'code')

    const indexedSelections = useListIndexed(selections, 'code')

    const [fileNameDAI, setFileNameDAI] = useState()
    const [campaignModels, setCampaignModels] = useState([])

    useEffect(() => {
        // une planification pas encore enregistrée (id négatif) n'existe pas en base, où les modèles campagne lisent leurs données
        if (isOpen && (isNil(planningId) || planningId > 0)) {
            dispatch(ExportAction.getEnvironmentModelsByType('qualityCampaign')).then(res => setCampaignModels(res || []))
        }
    }, [dispatch, isOpen, planningId])

    const selectedCampaignPlanning = useMemo(() => campaignPlannings.find(({ id }) => id === planningId), [planningId, campaignPlannings, isOpen])

    const defaultStartDate = selectedCampaignPlanning ? selectedCampaignPlanning.startDate : getTimestamp(campaign.beginningApplication)

    const defaultEndDate = selectedCampaignPlanning ? selectedCampaignPlanning.endDate : getTimestamp(campaign.endingApplication) ?? defaultStartDate

    useEffect(() => {
        setFileNameDAI(
            selectedCampaignPlanning ?
                formatedFileName(`PLANIF-${moment(defaultStartDate).format('DD/MM/YYYY').slice(0, 2)}-${moment(defaultEndDate).format('DD/MM/YYYY').slice(0, 2)}-${moment(defaultEndDate).format('DD/MM/YYYY').slice(3)}-DAI`)
                :
                formatedFileName(`${campaign.name}-DAI`),
        )
    }, [isOpen, selectedCampaignPlanning, campaign])

    // const initDAI = () => {
    //     const lastFile = maxBy(edilaboFiles, 'updateDate')
    //     const exportPath = lastFile ? lastFile.href.split('EXPORT/EDILABO/')[1].replace(lastFile.label, '') : ''
    //     return {
    //         campaignId: campaign.id,
    //         requestName: `DAI ${campaign.name}`,
    //         exportPath,
    //         startDate: getTimestamp(campaign.beginningApplication),
    //         endDate: getTimestamp(campaign.endingApplication),
    //         codifications: campaignStations.map(({ stationId, codification }) => ({ stationId, codification })),
    //         sender: !isNil(campaign.contributorCode) ? parseInt(campaign.contributorCode) : undefined,
    //         receiver: (() => {
    //             const samplerCode = !isNil(campaign.samplerCode) ? parseInt(campaign.samplerCode) : undefined
    //             const recipientCode = !isNil(campaign.recipientCode) ? parseInt(campaign.recipientCode) : undefined
    //             switch (campaign.requestType) {
    //                 case '1':
    //                     return samplerCode
    //                 case '2':
    //                     return recipientCode
    //                 case '3':
    //                     return recipientCode || samplerCode
    //                 default:
    //                     return undefined
    //             }
    //         })(),
    //     }
    // }

    // const initRAI = () => {
    //     const lastFile = maxBy(edilaboFiles, 'updateDate')
    //     const exportPath = lastFile ? lastFile.href.split('EXPORT/EDILABO/')[1].replace(lastFile.label, '') : ''
    //     const sender = (() => {
    //         const samplerCode = !isNil(campaign.samplerCode) ? parseInt(campaign.samplerCode) : undefined
    //         const recipientCode = !isNil(campaign.recipientCode) ? parseInt(campaign.recipientCode) : undefined
    //         switch (campaign.requestType) {
    //             case '1':
    //                 return samplerCode
    //             case '2':
    //                 return recipientCode
    //             case '3':
    //                 return recipientCode || samplerCode
    //             default:
    //                 return undefined
    //         }
    //     })()
    //     const receiver = !isNil(campaign.contributorCode) ? parseInt(campaign.contributorCode) : undefined
    //     return {
    //         campaignId: campaign.id,
    //         requestName: `RAI ${campaign.name}`,
    //         exportPath,
    //         startDate: getTimestamp(campaign.beginningApplication),
    //         endDate: getTimestamp(campaign.endingApplication),
    //         receiver,
    //         producer: receiver,
    //         sender,
    //         laboratory: sender,
    //     }
    // }

    // const [paramDAI, setParamDAI] = useState({})
    // const [paramRAI, setParamRAI] = useState({})

    // useEffect(() => {
    //     if (!isOpen) return
    //     setParamDAI(initDAI())
    //     setParamRAI(initRAI())
    // }, [isOpen])

    const types = useMemo(getParametersType, [])
    const natures = useMemo(getParametersNature, [])

    const getFormattedStations = () => {
        const countPlanning = (stationId) => {
            return campaignPlannings.reduce((nb, planning) => {
                if (planning.stationsPlan.includes(stationId)) return nb + 1
                return nb
            }, 0)
        }

        const formattedStations = campaignStations.map(cs => {
            const qualito = indexedQualitometers[cs.stationId]
            return {
                code: qualito?.code,
                city: qualito?.townCode ? indexedCities[qualito?.townCode]?.name : undefined,
                name: qualito?.name,
                codification: codificationsList.find(c => c.code === cs.codification)?.name,
                samplePoint: groupedSamplePoints[cs.stationId]?.find(p => p.idPoint === cs.samplePoint)?.displayLabel,
                nbUsedInPlanning: countPlanning(cs.id),
            }
        })
        return formattedStations.length ? [
            { ...formattedStations[0], headers: keys(formattedStations[0]) },
            ...formattedStations.slice(1),
        ] : []
    }


    const getFormattedParameters = () => {
        const countPlanning = (paramId) => {
            return campaignPlannings.reduce((nb, planning) => {
                if (planning.parametersPlan.includes(paramId)) return nb + 1
                return nb
            }, 0)
        }

        const formattedParameters = campaignParameters.map(cp => {
            const parameter = indexedParameters[cp.parameterCode]
            const unit = indexedUnits[cp.unitCode]
            return {
                code: cp.parameterCode,
                name: parameter?.name,
                type: types[parameter?.typeParam],
                nature: natures[parameter?.nature],
                status: parameter?.status ? getStatusInformation(parameter?.status) : i18n.validated,
                codeUnit: unit?.code,
                unit: unit?.symbol,
                fractionCode: cp.fractionCode,
                fraction: indexedFractions[cp.fractionCode]?.name,
                supportCode: cp.supportCode,
                support: indexedSupports[cp.supportCode]?.name,
                place: getLocalizationLabel(cp.placeCode),
                nbUsedInPlanning: countPlanning(cp.id),
            }
        })
        return formattedParameters.length ? [
            { ...formattedParameters[0], headers: keys(formattedParameters[0]) },
            ...formattedParameters.slice(1),
        ] : []
    }

    const getFormattedPlannings = () => {
        const formattedPlannings = orderBy(campaignPlannings, 'startDate').map(p => {
            return {
                startDate: getDate(p.startDate),
                endDate: getDate(p.endDate),
                completion: contributors.find(({ id }) => id === p.producer)?.name,
                mnemonique: contributors.find(({ id }) => id === p.producer)?.mnemonique,
                nbStations: `${p.stationsPlan.length}`,
                nbParam: `${p.parametersPlan.length}`,
                selection: indexedSelections[p.selection]?.name,
            }
        })
        return formattedPlannings.length ? [
            { ...formattedPlannings[0], headers: keys(formattedPlannings[0]) },
            ...formattedPlannings.slice(1),
        ] : []
    }

    const exportFullCampaign = (exportType) => {
        const baseTitle = campaign.name || `${i18n.campaigns}_${i18n.quality}`

        const formattedStations = getFormattedStations()
        const formattedParameters = getFormattedParameters()
        const formattedPlannings = getFormattedPlannings()

        if (formattedStations.length === 0 && formattedParameters.length === 0 && formattedPlannings.length === 0) {
            dispatch(ToastrAction.error(i18n.noData))
            return
        }

        if (formattedStations.length > 0) {
            dispatch(ExportAction.export(formatData(formattedStations, exportType), exportType, `${baseTitle}_${i18n.stations}`))
        }

        if (formattedParameters.length > 0) {
            dispatch(ExportAction.export(formatData(formattedParameters, exportType), exportType, `${baseTitle}_${i18n.parameters}`))
        }

        if (formattedPlannings.length > 0) {
            dispatch(ExportAction.export(formatData(formattedPlannings, exportType), exportType, `${baseTitle}_${i18n.plannings}`))
        }
    }

    const campaignModelExports = campaignModels.map(model => ({
        name: model,
        formats: [{
            type: i18n.excelFile,
            callback: () => dispatch(ExportAction.exportCampaignModel({ campaignId: campaign.id, planningId, stationType: 'quality' }, model)),
        }],
    }))

    const exportChoices = [{
        name: i18n.excelExport,
        formats: [{
            type: i18n.excelFile,
            callback: () => exportFullCampaign('xlsx'),
        }, {
            type: i18n.csvFile,
            callback: () => exportFullCampaign('csv'),
        }],
    }, {
        name: i18n.EDILABODAI,
        formats: [{
            type: i18n.xmlFile,
            callback: () => {
                const lastFile = maxBy(edilaboFiles, 'updateDate')
                const exportPath = lastFile ? lastFile.href.split('EXPORT/EDILABO/')[1].replace(lastFile.label, '') : ''
                const samplerCode = hasValue(campaign.samplerCode) ? parseInt(campaign.samplerCode) : undefined
                const recipientCode = hasValue(campaign.recipientCode) ? parseInt(campaign.recipientCode) : undefined
                const getReceiver = () => {
                    switch (campaign.requestType) {
                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.SAMPLE_REQUEST:
                            return samplerCode
                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.ANALYSIS_REQUEST:
                            return recipientCode
                        case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.MIXED_REQUEST:
                            return recipientCode || samplerCode
                        default:
                            return undefined
                    }
                }
                dispatch(ExportAction.exportEDILABOPlanning({
                    campaignId: campaign.id,
                    exportPath,
                    requestName: fileNameDAI,
                    startDate: defaultStartDate,
                    endDate: defaultEndDate,
                    codifications: [], // [{ stationId: Int, codification: Int }]
                    sender: hasValue(campaign.contributorCode) ? parseInt(campaign.contributorCode) : undefined,
                    receiver: getReceiver(),
                    planningId,
                })).then(onClose)
            },
        }],
        settingsContent: (
            <>
                {campaignStations.length && campaignParameters.length
                    ? <SimpleInput
                        title={i18n.fileName}
                        value={fileNameDAI}
                        onChange={(v) => setFileNameDAI(v)}
                        onBlur={() => setFileNameDAI(formatedFileName(fileNameDAI))}
                        maxLength={34}
                        helperText={template(i18n.maxXCharacters)({ nbChar: 34 })}
                    />
                    : <Typography sx={{ fontWeight: 'bold', color: errorColor }}>{i18n.cannotExportDAI}</Typography>
                }
                {
                    compact([campaign.recipientCode, campaign.samplerCode, campaign.contributorCode]).some(id => isNil(contributors.find(c => c.id === parseInt(id))?.siret)) &&
                    <Stack direction='row' spacing={1} alignItems='center' sx={{ paddingTop: '5px' }}>
                        <WarningIcon fontSize='small' sx={{ color: warningColor }} />
                        <Typography sx={{ fontWeight: 'bold', color: warningColor }}>{i18n.siretUndefined}</Typography>
                    </Stack>
                }

            </>
        ),
        isReady: () => campaignStations.length && campaignParameters.length && !isNil(fileNameDAI),
    // }, {
    //     name: i18n.EDILABORAI,
    //     formats: [{
    //         type: i18n.xmlFile,
    //         // callback: onOpenRai,
    //     }],
    //     settingsContent: (
    //         <FormExportEDILABO
    //             paramEDILABO={paramRAI}
    //             setParamEDILABO={setParamRAI}
    //             fullForm
    //         />
    //     ),
    //     isReady: () => ['requestName', 'sender', 'receiver', 'laboratory', 'producer', 'startDate', 'endDate'].every(key => !isNil(paramRAI[key])),
    }]
    return (
        <ExportFileModal
            open={isOpen}
            onClose={onClose}
            data={[...exportChoices, ...campaignModelExports]}
        />
    )
}

QualityCampaignExportPopup.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    planningId: PropTypes.number,
}

export default QualityCampaignExportPopup